<ion-grid class="cardContainer">
  <ion-row>
    <ion-col size="12">
      <h2 class="text-center mb-0 text-lg">
        <strong>{{ avtale.anleggsadresse }}</strong>
      </h2>
      <p class="text-center mb-0 mt-1">
        {{ avtale.navn }}
      </p>
    </ion-col>
  </ion-row>

  <ion-row class="ion-margin-top ion-margin-bottom">
    <ion-col [ngSwitch]="avtale.produktgruppe" class="priceCol" size="12">
      <div
        *ngIf="avtale.produktgruppe === 'Spotpris' && timensSpotpris"
        class="priceContainer"
        [class.mobile]="this.platform.is('mobile')"
      >
        <ion-row>
          <ion-col>
            <p class="noMargin">
              Pris kl. {{ today.getHours() }} - {{ today.getHours() + 1 }}:
            </p>
            <p class="price">{{ timensSpotpris }} øre/kWh</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <p>
              Snittpris i dag:
              <b
                >{{ avtale.dagensPris.toFixed(2).replace('.', ',') }} øre/kWh</b
              >
            </p>
            <p class="noMargin">
              Inkl. ditt påslag:
              <b
                >{{ avtale.paaslagOre.toFixed(2).replace('.', ',') }} øre/kWh</b
              >
            </p>
            <p
              class="more-prices hover:cursor-pointer"
              (click)="navigateToSpot()"
            >
              Klikk her for å se spotprisen
            </p>
          </ion-col>
        </ion-row>
      </div>

      <div
        class="priceContainer"
        [class.mobile]="this.platform.is('mobile')"
        *ngIf="
          avtale.produktgruppe !== 'Spotpris' ||
          (avtale.produktgruppe === 'Spotpris' && timensSpotpris === undefined)
        "
      >
        <p *ngSwitchCase="'Fastpris'" class="m-0">Din fastpris</p>
        <p *ngSwitchCase="'Spotpris'" class="m-0">Dagens snittpris</p>
        <p *ngSwitchCase="'Felleskraft'" class="m-0">Denne måneden</p>
        <p *ngSwitchCase="'Forutsigbar strøm'" class="m-0">Denne måneden</p>
        <p *ngSwitchDefault class="m-0">Gjeldende pris</p>

        <p class="price">
          {{
            avtale.dagenPrisStipulert
              ? avtale.sistePris.toFixed(2).replace('.', ',')
              : avtale.dagensPris.toFixed(2).replace('.', ',')
          }}
          øre/kWh
        </p>
        <p
          *ngIf="avtale.produktgruppe === 'Spotpris' && avtale.paaslagOre"
          class="noMargin"
        >
          inkl. påslag
          {{ avtale.paaslagOre.toFixed(2).replace('.', ',') }} øre/kWh
        </p>
        <p *ngIf="avtale.nesteMndPris" class="noMargin">
          Neste måned:
          {{ avtale.nesteMndPris.toFixed(2).replace('.', ',') }} øre/kWh
        </p>
        <p
          *ngIf="
            (avtale.produktgruppe === 'Felleskraft' ||
              avtale.produktgruppe === 'Forutsigbar strøm') &&
            !avtale.nesteMndPris
          "
          class="noMargin"
        >
          Neste måned: Ikke fastsatt
        </p>
      </div>
    </ion-col>

    <ion-col size="6" class="paddingLeft">
      <p class="bold mb-0">Fastbeløp</p>
      <p class="mt-2">{{ avtale.fastbelopMndKr }} kr/mnd</p>
    </ion-col>

    <ion-col size="6">
      <p class="bold mb-0">Bindingstid</p>
      <p class="mt-2">
        {{
          avtale.binding
            ? (avtale.bindingTil | date : 'dd. MMMM yyyy' : '' : 'nb')
            : 'Ingen bindingstid'
        }}
      </p>
    </ion-col>
    <ion-col
      size="12"
      class="paddingLeft paddingRight"
      *ngIf="showOmAvtalen && avtaleDesc"
    >
      <p class="bold mb-0">Om avtalen</p>
      <p class="avtaledescription mt-2">
        {{ avtaleDesc.short_description }}
      </p>
    </ion-col>
  </ion-row>
</ion-grid>
